import React, { useMemo } from 'react';
import { Card, Tooltip } from 'antd';
import { StringUtils } from '../utils/strings';
import EvolutionLabel from './layout/evolutionLabel';

const SummaryCard = ({
  title, 
  content, 
  selected = false, 
  action, 
  selectable = true,
  tooltipText = null,
  comparisonState,
  comparisonValue = null,
  disabled = false
}) => {

  // Memoize class name calculation to prevent unnecessary recalculations
  const cardClassName = useMemo(() => {
    if (!selectable) return disabled ? "summary-card summary-card-blocked summary-card-disabled" : "summary-card summary-card-blocked";
    return selected 
      ? "summary-card summary-card-selected" 
      : "summary-card";
  }, [selectable, selected, disabled]);

  // Memoize formatted content to prevent unnecessary recalculations
  const formattedContent = useMemo(() => {
    if(disabled) return content;
    const numericContent = parseFloat(content) || 0;
    return StringUtils.formatNumberAbbreviation(numericContent);
  }, [content, disabled]);

  // Determine click handler based on selectability
  const handleClick = selectable ? action : undefined;

  return (
    <Tooltip title={tooltipText ?? tooltipText} color="#001529">
      <Card 
        className={cardClassName} 
        onClick={handleClick}
        style={{ 
          cursor: selectable ? 'pointer' : 'default',
          transition: 'all 0.3s ease'
        }}
      >
         {comparisonState && StringUtils.isNumeric(comparisonValue) ? <span className="floating"><EvolutionLabel value={comparisonValue}/></span> : null}
         <p>{formattedContent}</p>
         <span className="title">{title}</span>
      </Card>
    </Tooltip>
  ); 
};
export default SummaryCard;